define([
	"dojo/_base/declare",
	"dojo/keys",
	"tributejs",
	"csi/_base/underscore",
	"csi/locale",
	"csi/util",
	"./Dialog",
	"./DialogForm",
	"./froalaTextEditor",
	"csi/widget/ErrorText",
	"csi/widget/ValidationTextBox",
	"dojo/text!./CommentDialog.html",
], function(declare,keys,Tribute,_,locale,util,Dialog,DialogForm,froalaTextEditor,ErrorText,ValidationTextBox,template) {

	return declare(Dialog, {
		// summary: Pops up a comment dialog for setting color and text
		dialogActions: true,
		destroyOnHide: true,
		formTemplate: template,
		subjectNode: null,

		_onSubjectKey: function(/*Event*/e) {
			if (e.keyCode == keys.TAB) {
				// .focus() dosen't work on all browsers as expected so using jquery focus function
				$(this.richTextNode.focusNode).focus();
				e.preventDefault();
			}
		},

		onCreate: function() {
			//set overflow visible for dialog so html editor toolbar popups are not cut off
			this.inherited(arguments);
			$(this.domNode).css('overflow','visible');
		},

		postMixInProperties: function() {
			this.id = this.id || "CommentDialog_" + util.uuid();

			this.form = new DialogForm({
				templateString: this.formTemplate
			});

			this.form.focus = function() { };

			this.richTextNode = new froalaTextEditor({
				csiRefNode: this.csiRefNode,
				name: "text",
				heightMin: 250,
				heightMax: 320,
				bHideLinkEditPopup: true, // Hide "Edit Link" button in link options popup
				scrollableContainer: "#" + this.id,
				tabIndex: 2,

				// trigger dialog to resize and reposition itself after the froala editor is initialized
				onInit: () => this._onInitFroala()
			}, this.form.editorNode);
			
			if (this.form.subjectNode) {
				var subjectTextbox = new ValidationTextBox({
					"class": "csiCommentDialogSubject",
					customErrorHandling: true,
					name: "subject",
					required: true
				});
				
				subjectTextbox.placeAt(this.form.subjectNode);
				
				new ErrorText({
					inputWidget: subjectTextbox,
					"class": "csi-error-message"
				}).placeAt(this.form.subjectNode);
				
				this.subjectNode = subjectTextbox;
				this.subjectNode.focusNode.tabIndex = 1;
				this.connect(this.subjectNode, "onKeyPress", "_onSubjectKey");
				this.richTextNode.focusOnLoad = false;
			}

			this.inherited(arguments);
		},

		/**
		 * Recenter dialog after Froala is initialized
		 */
		_onInitFroala: function() {
			this.resize();
			this._position();
			const tribute = new Tribute({
				values: [],
				noMatchTemplate: () => {
					return '<div class="tribute-container-latency"><div class="csi-message-icon material-icons csi-material-icon-error">error</div><div class="message">'+locale.resource("MentionFeatureNotAvailable")+'</div><div>'
				},
 			});
			tribute.attach(this.richTextNode.froalaEditor.el);
			//set the focus to rich text box
			if (!this.form.subjectNode) {
				setTimeout(() => {
				    $(this.richTextNode.froalaEditor.el).focus();
				},300);
			}	
		}
	});
});
